var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"skimovie",attrs:{"title":_vm.$t('skimovieView.skimovie'),"icon":"video-slash"}},[_c('SkimovieProblems')],1)}
var staticRenderFns = []

export { render, staticRenderFns }